
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/ban-ts-comment*/
/* eslint-disable @typescript-eslint/naming-convention*/
/* eslint-disable no-empty*/
/* eslint-disable @typescript-eslint/restrict-plus-operands*/
import { WebRTCAdaptor } from "../../antmedia/webrtc_adaptor";
import { getUrlParameter } from "../../antmedia/fetch.stream";

const token = getUrlParameter("token");
let publishStreamId = getUrlParameter("streamId");
let playOnly = getUrlParameter("playOnly");
const subscriberId = getUrlParameter("subscriberId");
const subscriberCode = getUrlParameter("subscriberCode");
let isPlaying = false;
let fullScreenId = -1;

if (playOnly == null) {
  playOnly = false;
}

const roomOfStream: any[] = [];

let roomTimerId: ReturnType<typeof setTimeout>;

export function makeFullScreen(divId: any) {

  if (fullScreenId == divId) {
    (document.getElementById(divId) as HTMLDivElement).classList.remove("selected");
    (document.getElementById(divId) as HTMLDivElement).classList.add("unselected");
    fullScreenId = -1;
  } else {
    document.getElementsByClassName("publisher-content")[0].className =
      "publisher-content chat-active fullscreen-layout";
    if (fullScreenId != -1) {
      (document.getElementById(fullScreenId.toString()) as HTMLDivElement).classList.remove("selected");
      (document.getElementById(fullScreenId.toString()) as HTMLDivElement).classList.add("unselected");
    }
    (document.getElementById(divId) as HTMLDivElement).classList.remove("unselected");
    (document.getElementById(divId) as HTMLDivElement).classList.add("selected");
    fullScreenId = divId;
  }
}

const pc_config = {
  iceServers: [
    {
      urls: "stun:stun1.l.google.com:19302",
    },
  ],
};

const sdpConstraints = {
  OfferToReceiveAudio: false,
  OfferToReceiveVideo: false,
};

const mediaConstraints = {
  //setting constraints here breaks source switching on firefox.
  video: {
    width: { max: 320 },
    height: { max: 240 },
  },
  audio: true,
};

const websocketURL = process.env.REACT_APP_VIDEO_WSDASH_ADDRESS;
const errorDefinition = [
  { error: "NotFoundError", errorMessage: "Camera or Mic are not found or not allowed in your device." },
  { error: "NotReadableError", errorMessage: "Camera or Mic is being used by some other process that does not not allow these devices to be read." },
  { error: "TrackStartError", errorMessage: "Camera or Mic is being used by some other process that does not not allow these devices to be read." },
  { error: "OverconstrainedError", errorMessage: "There is no device found that fits your video and audio constraints. You may change video and audio constraints." },
  { error: "ConstraintNotSatisfiedError", errorMessage: "There is no device found that fits your video and audio constraints. You may change video and audio constraints." },
  { error: "NotAllowedError", errorMessage: "You are not allowed to access camera and mic." },
  { error: "PermissionDeniedError", errorMessage: "You are not allowed to access camera and mic." },
  { error: "TypeError", errorMessage: "Video/Audio is required." },
  { error: "UnsecureContext", errorMessage: "Fatal Error: Browser cannot access camera and mic because of unsecure context. Please install SSL and access via https" },
  { error: "WebSocketNotSupported", errorMessage: "Fatal Error: WebSocket not supported in this browser" },
  { error: "no_stream_exist", errorMessage: "No Stream Exist" },
  { error: "data_channel_error", errorMessage: "There was a error during data channel communication" },
  { error: "ScreenSharePermissionDenied", errorMessage: "You are not allowed to access screen share" },
  { error: "WebSocketNotConnected", errorMessage: "WebSocket Connection is disconnected." },


];
const getErrorMessage = (errorString: string) => {
  const errdef = errorDefinition.filter(x => x.error == errorString)
  if (errdef.length > 0)
    return errdef[0]
  else
    return { error: "", errorMessage: "" }
}
export const webRTCAdaptor = new WebRTCAdaptor({
  websocket_url: websocketURL,
  mediaConstraints: mediaConstraints,
  peerconnection_config: pc_config,
  sdp_constraints: sdpConstraints,
  isPlayMode: false,
  debug: true,
  callback: (info: string, obj: { ATTR_ROOM_NAME: any; streamId: number; streams: any; }) => {
    switch (info) {
      case "intialized":
        console.log("intialized...")
        break;
      case "joinedTheRoom": {
        const _room = obj.ATTR_ROOM_NAME;
        roomOfStream[obj.streamId] = _room;
        console.log(roomOfStream)
        publishStreamId = obj.streamId.toString();
        //@ts-ignore
        webRTCAdaptor.handleSetMyObj(obj);

        //@ts-ignore
        webRTCAdaptor.handlePublish(
          obj.streamId,
          token,
          subscriberId,
          subscriberCode
        );

        roomTimerId = setInterval(() => {
          //@ts-ignore
          webRTCAdaptor.handleRoomInfo(publishStreamId);
        }, 5000);
      }
        break;
      case "newStreamAvailable":
        //@ts-ignore
        webRTCAdaptor.handlePlayVideo(obj, publishStreamId);
        break;
      case "publish_started":
        //stream is being published
        //@ts-ignore
        webRTCAdaptor.handleRoomInfo(publishStreamId);
        break;
      case "screen_share_stopped":
        //@ts-ignore
        webRTCAdaptor.handleScreenshareNotFromPlatform();
        break;
      case "browser_screen_share_supported":
        console.log("browser_screen_share_supported")
        break;
      case "leavedFromRoom":
        if (roomTimerId !== null) {
          clearInterval(roomTimerId);
        }

        break;
      case "closed":
        console.log("closed...")
        break;
      case "play_finished":
        isPlaying = false;
        break;
      case "streamInformation":
        //@ts-ignore
        webRTCAdaptor.handleStreamInformation(obj);
        break;
      case "screen_share_started":
        //@ts-ignore
        webRTCAdaptor.screenShareOnNotification();
        break;
      case "roomInformation": {
        const tempList = [...obj.streams];
        tempList.push("!" + publishStreamId);
        //@ts-ignore
        webRTCAdaptor.handleRoomEvents(obj);
        if (!isPlaying) {
          //@ts-ignore
          webRTCAdaptor.handlePlay(token, tempList);
          isPlaying = true;
        }
        //Lastly updates the current streamlist with the fetched one.
      }
        break;
      case "data_channel_opened":
        setInterval(() => {
          //@ts-ignore
          webRTCAdaptor.updateStatus(obj);
        }, 2000);

        break;
      case "data_channel_closed":
        console.log("data_channel_closed..")
        break;
      case "data_received":
        try {
          //@ts-ignore
          webRTCAdaptor.handleNotificationEvent(obj);
        } catch (e) {
          console.error("Error:", e);
        }
        break;
      case "available_devices":
        //@ts-ignore
        webRTCAdaptor.devices = obj;
        break;
    }

  },
  callbackError: function (error: string | string[], message: string) {
    let errorMessage = JSON.stringify(error);

    //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError
    if (Array.isArray(error)) {
      error.forEach((e) => {
        const erm = getErrorMessage(e)
        if (erm.error !== "")
          errorMessage = erm.errorMessage
      })
    } else {
      const erm = getErrorMessage(error)
      if (erm.error)
        errorMessage = erm.errorMessage
    }

    if (typeof message != "undefined") {
      errorMessage = message;
    }
    errorMessage = JSON.stringify(error);
    if (error.indexOf("publishTimeoutError") != -1 && roomTimerId != null) {
      clearInterval(roomTimerId);
    }

    if (error.indexOf("NotFoundError") != -1
      || error.indexOf("NotReadableError") != -1
      || error.indexOf("TrackStartError") != -1
      || error.indexOf("OverconstrainedError") != -1
      || error.indexOf("ConstraintNotSatisfiedError") != -1) {
      alert(errorMessage);
    } else if (
      error.indexOf("NotAllowedError") != -1 ||
      error.indexOf("PermissionDeniedError") != -1
    ) {
      //@ts-ignore
      webRTCAdaptor.handleScreenshareNotFromPlatform();
    } else if (error.indexOf("ScreenSharePermissionDenied") != -1) {
      //@ts-ignore
      webRTCAdaptor.handleScreenshareNotFromPlatform();
    }

    console.error(errorMessage);
  },
});

export function getWindowLocation() {
  (document.getElementById("locationHref") as HTMLInputElement).value = window.location.href;
}

export function copyWindowLocation() {
  const copyText = (document.getElementById("locationHref") as HTMLInputElement);

  /* Select the text field */
  copyText.select();
  copyText.setSelectionRange(0, 99999); /* For mobile devices */

  /* Copy the text inside the text field */
  document.execCommand("copy"); // NOSONAR
}


